import React from 'react';

// Honest scarcity microcopy for the sign-up CTAs.
//
// Grounded in two TRUE constraints, so it's substantiable under the DMCCA 2024
// (false urgency is a banned practice; a genuine deadline is lawful):
//   1. The measurement only works in cold weather, a real seasonal window.
//   2. Each sensor covers one home for 2 to 3 weeks, so throughput is capped.
//
// Deliberately NOT here: countdown timers, fake stock counts, "hundreds signing
// up", or loss-framing. The research flagged all of those as legally risky,
// trust-eroding, or unsupported. `tone` swaps text colour for coral CTA banners
// (light) vs. plain white backgrounds (dark).
const SeasonalCapacityNote = ({ tone = 'dark', className = '' }) => {
  const color = tone === 'light' ? 'text-white/90' : 'text-gray-500';
  // `mx-auto` is load-bearing: index.css caps every <p> at max-width:75ch, which
  // otherwise leaves the box hugging the left even though the text is centred.
  return (
    <p className={`text-sm text-center mx-auto ${color} ${className}`}>
      <span aria-hidden="true">❄ </span>
      Readings only work in cold weather, so we book a limited number of
      assessments each winter, and each sensor covers one home for 2 to 3 weeks.
    </p>
  );
};

export default SeasonalCapacityNote;
